import {
  CatalogIcon,
  ArrowUpStemIcon,
  ArrowDownStemIcon,
  DirectSalesIcon,
  ClockNoHandIcon,
} from '@floriday/floriday-icons'
import {
  SidebarDrawer,
  SidebarNavigation,
  SidebarNavigationItems,
  SidebarNavigationItem,
} from '@floriday/floriday-ui'
import { RfhColors } from '../../config/florimixColors'
import { KnownSidebarModules } from '../../types/sidebarModules'
import { useRouterState } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getOpeningHoursOverviewUrl } from '../../utils/openingHours'
import { MoveIcon } from '@floriday/floriday-icons'
import Box from '@mui/material/Box'

const sidebarItemsByRoute: {
  sidebarItem: KnownSidebarModules
  routes: string[]
}[] = [
  { sidebarItem: KnownSidebarModules.Dashboard, routes: ['/'] },
  { sidebarItem: KnownSidebarModules.NieuweUitgifte, routes: ['/collecting'] },
  { sidebarItem: KnownSidebarModules.NieuweInname, routes: ['/returning'] },
  { sidebarItem: KnownSidebarModules.Transacties, routes: ['/transactions'] },
]

export const LogisticMeansPortalSidebar = ({
  open,
  setOpen,
}: {
  open: boolean
  setOpen: (open: boolean) => void
}) => {
  const { t, i18n } = useTranslation()
  const pathname = useRouterState({ select: s => s.location.pathname })
  const currentSidebarItem =
    sidebarItemsByRoute.find(r => r.routes.includes(pathname))?.sidebarItem ??
    KnownSidebarModules.Dashboard

  const handleOpenModule = (module: string) => {
    if (module !== KnownSidebarModules.Openingstijden) {
      return
    }

    setOpen(false)
    const language = i18n.resolvedLanguage === 'en' ? 'en' : 'nl'
    window.open(
      getOpeningHoursOverviewUrl(language),
      '_blank',
      'noopener,noreferrer'
    )
  }

  return (
    <SidebarDrawer open={open} onClose={() => setOpen(false)}>
      <SidebarNavigation>
        <SidebarNavigationItems
          activeModule={currentSidebarItem}
          onOpenModule={handleOpenModule}
          onRequestClose={() => {}}
        >
          <SidebarNavigationItem
            module={KnownSidebarModules.Dashboard}
            title={t('common.dashboard')}
            color={RfhColors.royalPurple}
            icon={<CatalogIcon />}
            to={'/'}
          />
          <SidebarNavigationItem
            module={KnownSidebarModules.NieuweUitgifte}
            title={t('sidebar.newCollecting')}
            color={RfhColors.royalPurple}
            icon={<ArrowUpStemIcon />}
            to={'/collecting'}
          />
          <SidebarNavigationItem
            module={KnownSidebarModules.NieuweInname}
            title={t('sidebar.newReturning')}
            color={RfhColors.royalPurple}
            icon={<ArrowDownStemIcon />}
            to={'/returning'}
          />
          <SidebarNavigationItem
            module={KnownSidebarModules.Transacties}
            title={t('sidebar.transactions')}
            color={RfhColors.royalPurple}
            icon={<DirectSalesIcon />}
            to={'/transactions'}
          />
          <SidebarNavigationItem
            module={KnownSidebarModules.Openingstijden}
            title={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  flexDirection: 'row',
                }}
              >
                {t('sidebar.openingHours')}
                <MoveIcon color='disabled' />
              </Box>
            }
            color={RfhColors.royalPurple}
            icon={<ClockNoHandIcon />}
          />
        </SidebarNavigationItems>
      </SidebarNavigation>
    </SidebarDrawer>
  )
}
